export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '';
export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY ?? '';

export const GOOGLE_DRIVE_SCOPE = 'https://www.googleapis.com/auth/drive.file';
export const GOOGLE_DRIVE_FOLDER_NAME = 'Budgeter';
export const GOOGLE_DRIVE_MIME_JSON = 'application/json';
export const GOOGLE_DRIVE_MIME_FOLDER =
  'application/vnd.google-apps.folder' as const;

export function isGoogleDriveConfigured(): boolean {
  return GOOGLE_CLIENT_ID.length > 0 && GOOGLE_API_KEY.length > 0;
}
